var exports = {
  "K": "SavedMessagesPage.module__icon___S2RTcj",
  "r": "SavedMessagesPage.module__missingList___S2RTcj",
};

module.exports = exports;
